module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen3@2x-439ba5376a43dd9988a010349b3f86f0.png";